/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, start: NonNullable<unknown>, end: NonNullable<unknown> }} Sub_Overview_Active_UntilInputs */



/**
* | output |
* | --- |
* | "Active until {date} · Billing period: {start} → {end}" |
*
* @param {Sub_Overview_Active_UntilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_overview_active_until = /** @type {((inputs: Sub_Overview_Active_UntilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Overview_Active_UntilInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktiv bis ${i?.date} · Abrechnungszeitraum: ${i?.start} → ${i?.end}`)
	return /** @type {LocalizedString} */ (`Active until ${i?.date} · Billing period: ${i?.start} → ${i?.end}`)
});